import { View } from "binder"
import { ChartElement } from "./chart-viewModel"
import { FormBuilderComponentView } from "src/formBuilder/structure/element";

export class ChartView extends FormBuilderComponentView<ChartElement>{
    GetViewUniqueId(): string {
        return "V-2E0E1345-9656-4075-87F7-BFF4A84753DC"
    }
    loadHtml(): string {
        let element = require('./chart.html').default;
        let style = require('./chart.less');
        return element;
    }
    constructor() {
       super();
    }
}
